module.exports = __webpack_public_path__ + "media/toolkits/block-3-image-ac908a56.png";